import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { Device } from './device.model';
import { DeviceService } from './device.service';

@Component({
    selector: 'dcs-device-detail',
    templateUrl: './device-detail.component.html'
})
export class DeviceDetailComponent implements OnInit, OnDestroy {

    device: Device;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private deviceService: DeviceService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['device']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.deviceService.find(id).subscribe(device => {
            this.device = device;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/device/device-detail.component.ts